const padLeft = (str: number, length: number, padChar: string): string => {
  let text = str.toString();
  while (text.length < length) {
    text = padChar + text;
  }
  return text;
};

const secondsToTimeString = (seconds: number): string => {
  const date = new Date(seconds * 1000);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const secondsString = date.toISOString().substr(17, 6);

  return `${padLeft(hours, 2, "0")}:${padLeft(minutes, 2, "0")}:${secondsString}`;
};

export default secondsToTimeString;
